import { render, staticRenderFns } from "./manualReissue.vue?vue&type=template&id=2fbe5b52&scoped=true&"
import script from "./manualReissue.vue?vue&type=script&lang=js&"
export * from "./manualReissue.vue?vue&type=script&lang=js&"
import style0 from "./manualReissue.vue?vue&type=style&index=0&id=2fbe5b52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbe5b52",
  null
  
)

export default component.exports